import { render, staticRenderFns } from "./turn-into-clue.vue?vue&type=template&id=2da3a7f9&scoped=true"
import script from "./turn-into-clue.vue?vue&type=script&lang=js"
export * from "./turn-into-clue.vue?vue&type=script&lang=js"
import style0 from "./turn-into-clue.vue?vue&type=style&index=0&id=2da3a7f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3a7f9",
  null
  
)

export default component.exports